define('widgets/dgrid/blocks/lastplayed/lastPlayed',['underscore', 'knockout'], function (_, ko) {

    var LastPlayedBlock = function (DGridData, cmsGames, getFields) {
        var self = this;

        self.headline = getFields('headline');

        self.lastPlayedGameId = ko.deferredComputed(function() {
            var games = DGridData.lastPlayedGames();

            return games.length ? _.first(games) : null;
        });

        self.game = cmsGames.mobileGames.getGameByProviderGameId(self.lastPlayedGameId);

    };

    LastPlayedBlock.prototype.activate = function(settings) {
        var self = this;

        self.activateFallback = settings.activateFallback;

        self.lastPlayedGameId.subscribeAndExec(function() {
            return self.activateFallback(self.lastPlayedGameId() ? false : true);
        });
    };

    return LastPlayedBlock;

});
